import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import constants from "../../../utils/constants";

//Components
import FormBoxIndex from "./Childs/FormBoxIndex";
import Selector from "./Childs/Selector";

//CommonComponents
import Description from "../../Common/Childs/Structure/Description";
import Title from "../../Common/Childs/Structure/Title";

import plus from "../../../assets/icons/plus-solid.svg";
import FormCard from "../../Common/Childs/Structure/FormCard";
import Form from "./Childs/Form";
import Delete from "./Delete";
import { useWallet } from "../../../context/WalletContextProvider";
import { useGlobal } from "../../../context/GlobalContextProvider";

const initialState = {
  campaign_id: 0,
  campaign_name: "",
  beneficiary_id: "",
  sponsor_id: 0,
  art_pack_id: 0,
  starts_on: null,
  ends_on: null,
  dates_locked: false,
  max_count: 1,
  beneficiary_distro_min: 0,
  beneficiary_distro_max: 100,
  sponsor_distro_min: 0,
  sponsor_distro_max: 100,
  artist_distro_min: 0,
  artist_distro_max: 100,
  seller_distro_min: 0,
  seller_distro_max: 100,
  status: false,
  ct_ends_on_unlimited: false,
  ct_no_limit_nft: false
};

const initialStateSelector = {
  art_pack_id: 0,
  artist_id: 0,
  artist_address: 0
}
const Index = () => {
  const { account, apiConstants } = useWallet();
  const { campaign, setSpinner, setCampaign, setArtPack, initialDistroPreset } = useGlobal();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [selectors, setSelectors] = useState([]);
  const [draftRestoreData, setDraftRestoreData] = useState(null);

  const loadTableData = async () => {
    setSpinner(true);
    setShowForm(false);
    setFormData(initialState);
    const res = await fetch(`/api/sponsor/${account}/campaign`);
    if (res.status === 200) {
      const data = await res.json();
      setData(data);
    }
    setSpinner(false);
  };

  useEffect(() => {
    if (account) loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  // Handle returning from preview to specific campaign edit or create mode
  useEffect(() => {
    if (location.state?.editCampaignId && data.length > 0) {
      const campaignId = location.state.editCampaignId;
      onEdit(campaignId);
      // Clear the state to prevent re-triggering
      window.history.replaceState(null, '');
    } else if (location.state?.createMode && location.state?.formDraft) {
      // Return to create form with draft data
      const draftData = JSON.parse(location.state.formDraft);
      setShowForm(true);
      setFormData(draftData.form || draftData); // Handle both old and new format
      setDraftRestoreData(draftData); // Store full draft data for Form component
      if (draftData.selectors) {
        setSelectors(draftData.selectors);
      }
      setCampaign(null);
      setArtPack(null);
      // Clear the state to prevent re-triggering
      window.history.replaceState(null, '');
    }
  }, [location.state, data]);

  const addNew = () => {
    setShowForm(true);
    setFormData(initialState);
    setCampaign(null);
    setArtPack(null);
  };

  const onDiscard = () => {
    setShowForm(false);
    setFormData(initialState);
    setDraftRestoreData(null);
    // Clear preview data when discarding
    sessionStorage.removeItem('previewCampaignId');
    sessionStorage.removeItem('previewCreateMode');
    sessionStorage.removeItem('previewFormDraft');
    sessionStorage.removeItem('previewReturnUrl');
  };

  const clearCampaingSelected = () => {
    sessionStorage.removeItem(constants.CAMPAIGN_IDENTIFIER);
    setCampaign(null)
    setArtPack(null)
  }

  const createItem = async (form, artPackDetails) => {
    setSpinner(true)
    const campaignRes = await fetch(`/api/sponsor/${account}/campaign`, {
      method: "POST",
      body: JSON.stringify({ ...form, artist_distro_min: artPackDetails?.min_artist_percentage + apiConstants.reddevcut }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
    const campaignResJSON = await campaignRes.json()
    const artistDistorPreset = Math.max(artPackDetails?.min_artist_percentage + apiConstants.reddevcut, initialDistroPreset.artist_distro)
    const sponsorDistorPreset = Math.min(100 - artistDistorPreset, initialDistroPreset.sponsor_distro)
    const default_preset = {
      distro_preset_id: 0,
      preset_name: "Distro",
      campaign_id: campaignResJSON.campaign_id,
      preset_order: 1,
      artist_distro: artistDistorPreset,
      sponsor_distro: sponsorDistorPreset,
      beneficiary_distro: Math.min((100 - artistDistorPreset - sponsorDistorPreset), initialDistroPreset.beneficiary_distro),
      seller_distro: 0,
    }
    const url = `/api/campaign/${campaignResJSON.campaign_id}/distropreset`;
    await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        ...default_preset,
        campaign_id: campaignResJSON.campaign_id,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
    loadTableData();
    onDiscard();
    setSpinner(false);
  };

  const updateItem = async (data, artPackDetails) => {
    try {
      setSpinner(true)
      const { id } = formData;
      const url = `/api/sponsor/${account}/campaign/${id}`;
      await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ ...data, artist_distro_min: artPackDetails?.min_artist_percentage + apiConstants.reddevcut }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }).then((res) => {
        loadTableData();
        setSpinner(false)
        onDiscard();
        setSelectors(initialStateSelector)
      });
    } catch {
      setSpinner(false)
    }
  };

  const deleteItem = async () => {
    const { id } = formData;
    const url = `/api/sponsor/${account}/campaign/${id}`;
    await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }).then(async (res) => {
      const json = await res.json();
      sessionStorage.removeItem(constants.CAMPAIGN_IDENTIFIER)
      sessionStorage.removeItem(constants.ART_PACK_IDENTIFIER)
      setCampaign(null)
      setArtPack(null)
      loadTableData();
      onDiscard();
      if (json.id === campaign?.campaign_id) clearCampaingSelected();
    });
  };

  const loadSelectors = async (id) => {
    const res = await fetch(`/api/artist/artpack/${id}`);
    const json = await res.json();
    const {
      art_pack_id,
      artist_id,
      artists
    } = json;
    const artist_address = artists[0].artist_address
    setSelectors({
      art_pack_id,
      artist_id,
      artist_address
    });
  };

  const onEdit = (id) => {
    setShowForm(true);
    const edit = data.filter((item) => Number(item.campaign_id) === Number(id));
    loadSelectors(edit[0].art_pack_id)
    setFormData({ ...edit[0], id });
  };

  const onDelete = (id) => {
    setShowForm(false);
    const edit = data.filter((item) => Number(item.campaign_id) === Number(id));
    setFormData({ ...edit[0], id, delete: true });
  };

  if (showForm) {
    return (
      <>
        <Title title="Campaign" />
        <Description text={'Configure your campaign’s website.'} />
        <FormCard>
          <Form
            handleSubmit={formData?.id ? updateItem : createItem}
            formData={formData}
            selector={selectors}
            onDiscard={onDiscard}
            typeCheck={formData?.id ? 'updateItem' : 'createItem'}
            draftRestoreData={draftRestoreData}
          />
        </FormCard>
      </>
    );
  }

  if (!showForm && formData?.id && formData?.delete) {
    return (
      <Delete
        onDiscard={onDiscard}
        handleSubmit={deleteItem}
        formData={formData}
      />
    );
  }

  return (
    <>
      <Title title="Campaign" />
      <Description text={"Configure your campaign’s website."} />
      <div className="add-btn" onClick={addNew}>
        Add a new campaign
        <img src={plus} className="add-icon" alt="img" />
      </div>
      <FormBoxIndex>
        <Selector
          data={data}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </FormBoxIndex>
    </>
  );
};

export default Index;
